//================================================================
//  Billing Page
//================================================================

//Libraries
import React, { useContext, useEffect, useState } from 'react';

//Contexts
import {GetUser} from '../../Library/GlobalContexts';

//Functions
import ReactBackend from '../../Library/reactBackend';

//Components
import PageComponent from '../../Components/PageComponent/PageComponent';
import PageHeader from '../../Components/PageHeader/PageHeader';
import BillingTableRow from './Components/BillingTableRow';
import SelectBox from '../../Components/SelectBox/selectbox';

//Images
import InfoIcon from '../../Components/Images/Icon_Info_Black.svg';
import LoadingIcon from '../../Components/Images/Loading_Ripple.svg';

//CSS
import './Billing.css';


export default function Billing() {

  //------------------------------------------------------
  //  useContexts
  //------------------------------------------------------
  
    const getUser = useContext(GetUser);

  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------

    // Used to change between > 'pending', 'onload', 'success', 'error-invalid', 'error-fatal', 'error-timeout'
    const [pageStatus, setPageStatus] = useState('success');

    // Holds the current projectId, used to prevent unnecessary reloads of the page
    const [projectIds, setProjectIds] = useState();

    // Holds invoices for the financial year
    const [invoices, setInvoices] = useState([]);

    // Filter by financial year
    const [financialYear, setFinancialYear] = useState('Select a Financial Year');

  //------------------------------------------------------
  //  useEffects
  //------------------------------------------------------

    // Onload get all invoices for all projects
    useEffect(()=>{

      // Conditions
      if (getUser === undefined) return;
      if (getUser.profile?.views === undefined) return;
      if (getUser.profile.views.projectsOwner?.length === 0) return setPageStatus('error-other');
      if (getUser?.profile?.views?.projectsOwner?.length === projectIds?.length) return;
      
      // Save the projectIds & Tell users this might take some time!
      setProjectIds(getUser.profile.views.projectsOwner);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getUser]);

    // Financial year filter
    useEffect(()=>{

      // Conditions
      if (financialYear === 'Select a Financial Year') return;

      setPageStatus('onload');

      // Request invoices for all owned projects
      //Set request body
      const requestBody = {
        "projectIdList": getUser.profile.views.projectsOwner,
        "financialYear": financialYear
      }

      ReactBackend('getAllInvoices', requestBody).then((response) => {

        if (response.status === 'success') {
          const arrayOfInvoices = response.responseBody.message;

          // We have invoices, show the user
          setInvoices(arrayOfInvoices);
          setPageStatus('success');
        
        } else {
          setPageStatus('error-fatal');
        }

      });

    }, [financialYear]);


  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <PageComponent
      requireSelectedResource={true}
      requireSelectedViews={['organization']}
      requiredRoles={['lendleaseAccount']}
      requiredRolesValue={'true'}
      status={pageStatus}
      header={
        <PageHeader
          title={'Billing'}
          body={
            <span>
              Browse invoices for lendlease.cloud Google projects.
            </span>
          }
        ></PageHeader>
      }

      // Loading screen, as retrieving invoices can take some time!
      body={
        <>
          <div className='PageComponent-Label'>
            <div className='PageComponent-LabelMessage'>
              <img style={{marginRight: "15px"}} src={InfoIcon} alt="Information Icon"></img>
              <p>Searching {getUser?.profile?.views?.projectsOwner?.length} projects for invoices, this will take a moment...</p>
            </div>
          </div>

          <div style={{textAlign: 'center'}}>
            <img alt="loading-circle-icon" src={LoadingIcon}></img>
          </div>
        </>
      }

      // Retrieved invoices, load the page
      successContent={
        <>

          {
            /* Coin Financial Years */
            <div className='Billing-Filter-Pane'>
              <div>
                <span>Financial Year:</span>
                <SelectBox
                  placeholder={financialYear}
                  value={financialYear}
                  arrayOfOptions={['Select a Financial Year', 'FY21-22', 'FY22-23', 'FY23-24', 'FY24-25', 'FY25-26', 'FY26-27']}
                  onChange={(e) => setFinancialYear(e.target.value)}
                ></SelectBox>
              </div>
            </div>
          }

          {/* Invoice table */}
          <div className='Billing-Invoices-Pane'>
            {
              financialYear === 'Select a Financial Year' ? (

                // No financial year selected yet
                <div className='PageComponent-Label'>
                  <div className='PageComponent-LabelMessage'>
                    <img style={{marginRight: "15px"}} src={InfoIcon} alt="Information Icon"></img>
                    <p>Please select a Financial Year in the dropdown above to get started.</p>
                  </div>
                </div>

              ) : (

                invoices.length > 0 ? (

                  // Show invoices
                  invoices?.map((project) =>(
                    <table className='Data-Table-Container'>
                      <tbody>
                        <BillingTableRow
                          rowData={project}
                        ></BillingTableRow>
                      </tbody>
                    </table>
                  ))

                ) : (

                  // No invoices found
                  <div className='PageComponent-Label'>
                    <div className='PageComponent-LabelMessage'>
                      <img style={{marginRight: "15px"}} src={InfoIcon} alt="Information Icon"></img>
                      <p>No invoices found.</p>
                    </div>
                  </div>

                )

              )
            }
          </div>

        </>
      }

      // User doesn't own any projects
      errorOtherContent={
        <div className='PageComponent-Label'>
          <div className='PageComponent-LabelMessage'>
            <img style={{marginRight: "15px"}} src={InfoIcon} alt="Information Icon"></img>
            <p>Sorry you don't own any projects.</p>
          </div>
        </div>
      }
    ></PageComponent>
  )
}
